import { useState } from "react";
import { Table } from "react-bootstrap";
import Laoder from "../../../../newLetter/Loader";

import style from "./agentInsurance.module.css";
import { getRequestByAuth } from "../../../../../../function/helper";
import { useEffect } from "react";
import dateTimeToJalali from "../../../../../../function/jalali/dateTimetoJalali";

function AgentInsurance() {
  const [isLoading, setIsLoading] = useState(false);
  const [data, setData] = useState({
    blockWallet: 0,
    res: [],
  });

  const getData = async () => {
    setIsLoading(() => true);
    const response = await getRequestByAuth("/wallet/v1/wallet-warranty/show");

    if (response) {
      setData(() => response);
      setIsLoading(() => false);
    }
  };

  useEffect(() => {
    getData();
  }, []);

  return (
    <section>
      <div>
        <h4 className={"font-style-none text-end " + style.title}>
          موجودی وجه الضمان
        </h4>
        <p>
          <span className={style.number}>
            {data.blockWallet.toLocaleString()}
          </span>
          <small> ریال</small>
        </p>
      </div>

      <div className="mt-5">
        <h6>لیست واریزی ها:</h6>

        <div className="w-100 overflow-x-auto px-1">
          <Table bordered={true} className="w-100" striped>
            <thead>
              <tr>
                <th>ردیف</th>
                <th>وجه</th>
                <th>توضیحات</th>
                <th>شماره پیگیری</th>
                <th>تاریخ</th>
              </tr>
            </thead>
            <tbody>
              {isLoading === true && (
                <tr>
                  <td colSpan={5}>
                    <Laoder />
                  </td>
                </tr>
              )}
              {isLoading === false &&
                data.res.map((item, idx) => (
                  <tr key={item.id}>
                    <td>{idx + 1}</td>
                    <td>
                      {typeof item.amount === "number"
                        ? item.amount.toLocaleString()
                        : item.amount}
                    </td>
                    <td>{item.description}</td>
                    <td>{item.issueTrackingCode}</td>
                    <td>{dateTimeToJalali(item.created_at).full}</td>
                  </tr>
                ))}
            </tbody>
          </Table>
        </div>
      </div>
    </section>
  );
}

export default AgentInsurance;
